const AUTH_KEY = "biltip_auth";
const USER_KEY = "biltip_user";
const AUTH_CONTEXT_KEY = "biltip_auth_context";

interface StoredAuth {
  token?: string;
  expiresAt?: number;
  [key: string]: unknown;
}

interface StoredUser {
  name?: string;
  [key: string]: unknown;
}

interface AuthStorageData {
  auth: StoredAuth;
  user: StoredUser;
}

export interface AuthContext {
  apiBaseUrl: string;
}

function setAuthContext(context: AuthContext | null) {
  if (typeof window === "undefined") return;
  if (context) {
    localStorage.setItem(AUTH_CONTEXT_KEY, JSON.stringify(context));
  } else {
    localStorage.removeItem(AUTH_CONTEXT_KEY);
  }
}

export function getAuthContext(): AuthContext | null {
  if (typeof window === "undefined") return null;
  try {
    const data = localStorage.getItem(AUTH_CONTEXT_KEY);
    return data ? (JSON.parse(data) as AuthContext) : null;
  } catch {
    return null;
  }
}

export function saveAuth(data: AuthStorageData, context?: AuthContext) {
  if (typeof window === "undefined") return;
  localStorage.setItem(AUTH_KEY, JSON.stringify(data.auth));
  localStorage.setItem(USER_KEY, JSON.stringify(data.user));
  if (context) {
    setAuthContext(context);
  }
}

export function loadAuth(): AuthStorageData | null {
  if (typeof window === "undefined") return null;
  try {
    const authRaw = localStorage.getItem(AUTH_KEY);
    const userRaw = localStorage.getItem(USER_KEY);
    if (!authRaw || !userRaw) return null;
    return {
      auth: JSON.parse(authRaw) as StoredAuth,
      user: JSON.parse(userRaw) as StoredUser,
    };
  } catch {
    return null;
  }
}

export function clearAuth() {
  if (typeof window === "undefined") return;
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem(USER_KEY);
  setAuthContext(null);
}
